if(!customElements.get('sheer-button')) {
  class ComponentSheerButton extends HTMLElement {
    
    constructor() {
      super();

      this.sheerId = this.dataset.sheerId;
      this.btn = this.querySelector('.sheer-btn');
      
      this.btn.addEventListener('click',()=>{

        if (!this.sheerId || typeof window.sheerId === 'undefined') {
          console.error('Error with SheerId')
        }
        else{
          var sheerSide = document.getElementById('sheer-side');
          sheerSide.classList.add('open');
          $s.showOverlay();
          var myProgramUrl = `https://services.sheerid.com/verify/${this.sheerId}/?customer_id=null&_ab=0&_fd=0&_sc=1/`;
          var myDiv = document.getElementById("my-sheer-form");
          myDiv.innerHTML = '';
          var myForm = window.sheerId.loadInlineIframe(myDiv, myProgramUrl);
          myForm.setOptions({ logLevel: "info" });
        }
      });
      
 
    }
  }
  customElements.define('sheer-button', ComponentSheerButton);
}